import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: []
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    siteName: {
      validations: []
    },
    notes: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    reference: {
      validations: []
    },
    loyaltyNumber: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First name',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last name *',
            mapping: 'lastName'
          }
        ]
      },      
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'What venue are you interested in? *',
            options: [
              { label: 'Berkeley Church', value: 'Berkeley Church' },
              { label: 'Airship 37', value: 'Airship 37' },
              { label: 'Field House', value: 'Field House' },
              { label: 'Berkeley Bicycle Club', value: 'Berkeley Bicycle Club' },
              { label: 'Berkeley Innovation Centre', value: 'Berkeley Innovation Centre' },
              { label: 'La Maquette', value: 'La Maquette' },
              { label: 'UnDecided', value: 'UnDecided' },
              { label: 'OP Catering', value: 'OP Catering' }
            ],
            mapping: 'siteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'What are you planning and when?',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'No of guests',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Where did you hear about us? *',
            options: [
              { label: 'Website', value: 'Website' },
              { label: 'Google Ad', value: 'Google Ad' },
              { label: 'Berkeley Open House', value: 'Berkeley Open House' },
              { label: 'Eventsource', value: 'Eventsource' },
              { label: 'Blog/Social', value: 'Blog/Social' },
              { label: 'Wedding Wire', value: 'Wedding Wire' },
              { label: 'Eventective', value: 'Eventective' },
              { label: 'YELP', value: 'YELP' },
              { label: 'Email Campaign', value: 'Email Campaign' },
              { label: 'LaMaq List', value: 'LaMaq List' },
              { label: 'Tourism Toronto', value: 'Tourism Toronto' },
              { label: 'Guest at Event', value: 'Guest at Event' },
              { label: 'Linkedin', value: 'Linkedin' },
              { label: 'Call IN', value: 'Call IN' },
              { label: 'Walk IN', value: 'Walk IN' },
              { label: 'Mail Out', value: 'Mail Out' },
              { label: 'Cold Call', value: 'Cold Call' },
              { label: 'Employee Referral', value: 'Employee Referral' },
              { label: 'External Referral', value: 'External Referral' },
              { label: 'Partner', value: 'Partner' },
              { label: 'Vendor Referral', value: 'Vendor Referral' },
              { label: 'Google AdWords', value: 'Google AdWords' }
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Promo Code',
            mapping: 'loyaltyNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Fields marked * are required. Please include as much information as you can.',
            mapping: 'headerLabel'
          }
        ]
      },
    ]
  },
  info: {
    title: 'Berkeley Events Contact Us Form',
    formId: '486',
    clientKey: '2FFE9A02-3C7F-44CB-9E15-6069392E1E37',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/berkeleyevents/form_structure.js